import React, {useState, useEffect}  from "react"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Footer from "components/SelfCheckin/Footer/Footer"
import { useTranslation } from 'react-i18next';

import {SelfCheckinStepEnum} from "components/shared/enums/global-enums.tsx";
import useStore from 'store/store'
import sitaLogo from 'assets/images/sitaLogo.png'
import aeroportalLogo from 'assets/images/aeroportalLogo.png'
// import eva from 'assets/images/airlines/bigeva.png'

import './AirlineSelection.scss'

export default function AirlineSelection(){
  const {t} = useTranslation();
  const [choosenAirline, ] = useState('');
  const storeActions = useStore((state)=> state.actions);
  
  const [redirect,] = useSelfCheckinNafigation();

  const airlines = [
    { img: sitaLogo, name: 'sita' }, 
    { img: aeroportalLogo, name: 'portal' } 
  ];

  function handleChooseAirline(airline){
    // if (airline !== airlines[0].name) return;
    redirect(0, SelfCheckinStepEnum.SCAN_PASSPORT, {airline: airline});
  } 

  useEffect(()=>{
    storeActions.setSelfCheckinChoicesInit();
  }, [storeActions]);

  return (

    <div className="as-cover-bloc">
      <div className="">
        <div className="font-1-heavy h3 c-txt uppercase white-color">{t("PLEASE SELECT YOUR AIRLINE")}</div>
        <div className="v-space-5"> </div>
        <Grid container spacing={2}>
          {airlines.map((airline, key) => (
            <Grid item xs={12} md={12} lg key={key} >
              <Box
                className={`img-btn  more-height  ${airline.name === choosenAirline ? 'active': ''}`}
                onClick={()=>handleChooseAirline(airline.name)}
                >
                <img src={airline.img} height="60" alt="" />
              </Box>
            </Grid>
          ))}
        </Grid>

      </div>

      <Footer />
    </div>
    
    )
}